<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>推荐位管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">推荐位列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="标题">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="上架" value="0"></el-option>
                    <el-option label="下架" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center">
          </el-table-column>
          <el-table-column label="强制观看" align="center">
            <template slot-scope="scope">
              <span class="greenColor" v-if="scope.row.isForceView == 1"
                >是</span
              >
              <span class="redColor" v-if="scope.row.isForceView == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column label="关闭类型" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.closeType == 0">不关闭</span>
              <span v-if="scope.row.closeType == 1">查看后关闭</span>
              <span v-if="scope.row.closeType == 2">手动关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="closeTime"
            label="倒计时(秒)"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="适配端" align="center">
            <template slot-scope="scope">
              <span
                v-for="(item, index) in config"
                :key="index"
                v-if="item.key == scope.row.useType"
                >{{ item.val }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <span
                v-for="(item, index) in cageryList"
                :key="index"
                v-if="item.id == scope.row.categoryId"
                >{{ item.name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.saleStatus == 0"
                >下架</span
              >
              <span class="greenColor" v-if="scope.row.saleStatus == 1"
                >上架</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.saleStatus == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.saleStatus == 1"
                >
                  禁用
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      cageryList: [],
      config: [],
    };
  },
  mounted() {
    this.getList();
    this.getList1();
    this.configList();
  },
  methods: {
    configList() {
      let param = {
        page: 1,
        pageSize: 999999,
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          let list = "";
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == 64) {
              list = arr[i].propValue;
            }
          }
          this.config = JSON.parse(list);
        })
        .catch()
        .finally();
    },
    getList1() {
      let param = {
        queryParams: [
          {
            name: "page_module",
            type: "select",
            values: [
              {
                itemKey: 1,
              },
            ],
          },
        ],
      };
      this.$axios
        .post(`admapi/categories/getCategoriesByModule`, param)
        .then(({ data }) => {
          this.cageryList = data;
        })
        .catch()
        .finally();
    },
    add() {
      this.$router.push("/operateAdd");
    },
    handleEdit(val) {
      this.$router.push({
        path: "operateAdd",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "title",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "sale_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/category-items/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.saleStatus == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.saleStatus == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/category-items/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.saleStatus == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/category-items/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
